/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import dayjs from "dayjs";

export const isValidDayjsValue = (value) =>
  Boolean(value) && dayjs(value).isValid();
